module.exports = __webpack_public_path__ + "img/orange_072.3149fc2a.png";